import { Icon } from '@graftcode/design-system'

import { getNavigationUrls } from '../../config/navigation'

import type { ProjectCreatedSuccessStep } from './ProjectCreatedSuccess.types'

import styles from './ProjectCreatedSuccess.module.scss'

export const Routes = {
  AcademyQuickStart: `${getNavigationUrls().academy}/quick-start`,
}

export const steps: ProjectCreatedSuccessStep[] = [
  {
    key: 'quickstart',
    icon: Icon.FastForwardRegular,
    iconClass: styles.iconPrimary,
    highlighted: true,
    onClick: () => window.open(Routes.AcademyQuickStart, '_blank', 'noopener,noreferrer'),
  },
  {
    key: 'installClient',
    icon: Icon.ArrowDownloadRegular,
    iconClass: styles.iconSecondary,
    highlighted: false,
    onClick: undefined,
    disabled: true,
  },
  {
    key: 'usePackage',
    icon: Icon.BoxRegular,
    iconClass: styles.iconTertiary,
    highlighted: false,
    onClick: undefined,
    disabled: true,
  },
]
